module.exports = __webpack_public_path__ + "img/outtake_2.5e564fbd.jpeg";